import { connect } from "react-redux";
import CreditCardFieldset from "app/pages/Booking/Payment/CreditCardFieldset/CreditCardFieldset";
import { CREDIT_CARDS_TYPES } from "app/constants";

const mapStateToProps = state => {
	const selectedPaymentType = state.booking.paymentType;
	const selectedPaymentMode = state.booking.paymentMode;
	const paymentTypes = state.payment.paymentTypes;

	const selectedPaymentTypeData = paymentTypes.find(paymentType => {
		return (
			paymentType.paymentType === selectedPaymentType &&
			paymentType.terms === selectedPaymentMode
		);
	});

	let isAmexAvailable = true;

	if (selectedPaymentTypeData) {
		isAmexAvailable =
			selectedPaymentTypeData.acceptedCreditCardTypes &&
			selectedPaymentTypeData.acceptedCreditCardTypes.includes(CREDIT_CARDS_TYPES.AMEX);
	}

	return {
		selectedPaymentType,
		isAmexAvailable,
	};
};

export default connect(mapStateToProps)(CreditCardFieldset);
